import React from "react";
import {
  BsFillBellFill,
  BsFillEnvelopeFill,
  BsPersonCircle,
  BsSearch,
  BsJustify,
} from "react-icons/bs";
import { Store } from "react-notifications-component";
import { Link, useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FaUnlockKeyhole } from "react-icons/fa6";
import { IoIosLogOut } from "react-icons/io";

function Header({ OpenSidebar, pageName }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm("Are You Sure To Logout Your Account")) {
      localStorage.removeItem("auth_token_travel");

      Store.addNotification({
        title: "Success",
        message: "Logged out Successfully",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true,
        },
      });

      navigate("/");
    }
  };
  return (
    <>
      <header className="header">
        <div className="menu-icon">
          <BsJustify className="icon" onClick={OpenSidebar} />
        </div>
        <div
          className="header-left"
          style={{ fontSize: "25px", color: "#fff" }}
        >
          {/* <BsSearch className="icon" /> */}
          {pageName}
        </div>
        <div className="header-right">
          <Dropdown>
            <Dropdown.Toggle
              style={{ backgroundColor: "#64A433", border: "none" }}
              id="dropdown-basic"
            >
              <BsPersonCircle className="icon" />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/profile">
                <BsPersonCircle className="icon" /> Profile
              </Dropdown.Item>
              <Dropdown.Item as={Link} to="/changePassword">
                <FaUnlockKeyhole /> Change Password
              </Dropdown.Item>
              <Dropdown.Item onClick={handleLogout}>
                <IoIosLogOut /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </header>
    </>
  );
}

export default Header;
